import { isNonEmptyNumber } from '@labrav/common'
import type { ChannelPartnerPrivateOfferInCreation } from '../../../modules/channelPartnerPrivateOffer/reducer'
import type { ReceivedResellerAuthorization } from '../../../modules/receivedResellerAuthorization/reducer'
import { ContractDurationType, DiscountType } from '../../../types/flyout'
import { getPricesArray } from '../../../modules/resaleAuthorization/utils/getPricesArray'
import { getMappedKey } from '../../../utils/contractDuration'

export const getShowContractDurationOption = ({
  channelOffer,
  authorizationDuration,
  isAuthorizationFlexible,
  resellerAuthorization,
}: {
  channelOffer: ChannelPartnerPrivateOfferInCreation
  authorizationDuration?: ContractDurationType
  isAuthorizationFlexible: boolean
  resellerAuthorization?: ReceivedResellerAuthorization
}) => {
  if (isAuthorizationFlexible) return false
  const priceValue = getPricesArray(resellerAuthorization?.dimensions || [])
  const isMultiPrices = priceValue.length > 1

  const isMultipleTimeDuration =
    authorizationDuration === ContractDurationType.STANDARD && isMultiPrices

  const showDurationSelection = !!(
    ((!channelOffer?.flexiblePaymentTerms &&
      !channelOffer?.variableStartDate) ||
      channelOffer?.flexiblePaymentTerms) &&
    isMultipleTimeDuration
  )
  return showDurationSelection
}

export const getPricesArrayForDimensions = ({
  channelOffer,
  resellerAuthorization,
}: {
  channelOffer: ChannelPartnerPrivateOfferInCreation
  resellerAuthorization?: ReceivedResellerAuthorization
}) => {
  const priceValue = getPricesArray(resellerAuthorization?.dimensions || [])

  const showDurationSelection = getShowContractDurationOption({
    channelOffer: channelOffer,
    authorizationDuration: resellerAuthorization?.contractDurationType,
    isAuthorizationFlexible:
      resellerAuthorization?.discountType ===
      DiscountType.FLEXIBLE_PAYMENT_TERMS,
    resellerAuthorization,
  })

  const isCustomDuration =
    resellerAuthorization?.contractDurationType ===
      ContractDurationType.CUSTOM ||
    resellerAuthorization?.discountType === DiscountType.FLEXIBLE_PAYMENT_TERMS

  if (showDurationSelection) {
    const priceData = isNonEmptyNumber(channelOffer?.serviceLength)
      ? getMappedKey(String(channelOffer?.serviceLength))
      : ''
    return priceData ? [priceData] : []
  }

  if (isCustomDuration) {
    return ['price']
  }

  if (channelOffer?.variableStartDate && !channelOffer?.flexiblePaymentTerms) {
    return priceValue
  }

  return [priceValue[0]]
}
